"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var linkHelper = function linkHelper(href, external) {
  var parsedHref = href;

  if (external && !href.includes('{openNewTab}')) {
    parsedHref += '{openNewTab}';
  }

  var metadata = {
    allowIcon: false,
    openNewTab: false,
    relative: false,
    scrollTo: false
  };
  var customHooks = [];
  var metaSyntax = /(?:https?:\/\/)?{([^}]+)}/gi;
  parsedHref = parsedHref.replace(metaSyntax, function (_match, meta) {
    if (meta in metadata) {
      metadata[meta] = true;
    } else {
      customHooks.push(meta);
    }

    return '';
  });
  var isLocationalHref = parsedHref.length > 0 && parsedHref !== '#';
  return {
    allowIcon: metadata.allowIcon,
    href: parsedHref,
    hooks: customHooks,
    openNewTab: isLocationalHref && metadata.openNewTab && !metadata.scrollTo,
    scrollTo: metadata.scrollTo,
    relative: metadata.relative
  };
};

var _default = linkHelper;
exports["default"] = _default;